import { useState, type ImgHTMLAttributes } from "react";
import { thumbUrl } from "../../lib/thumb";

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> & {
  src?: string | null;
  /** Widest the image is drawn, in CSS pixels. Device pixel ratio is applied on top of this. */
  w: number;
};

/** An <img> that loads a small server-resized version, and falls back to the original if that fails. */
export default function ThumbImg({ src, w, onError, decoding = "async", ...rest }: Props) {
  const original = src || "";
  const [failedFor, setFailedFor] = useState<string | null>(null);
  const resolved = failedFor === original ? original : thumbUrl(original, w);
  return (
    <img
      {...rest}
      src={resolved || undefined}
      decoding={decoding}
      onError={(e) => {
        if (resolved !== original) setFailedFor(original);
        onError?.(e);
      }}
    />
  );
}
